import { motion } from "framer-motion";
import { WHATSAPP_LINK } from "@/constants/config";

export const CTAButton = ({ label, testId, size = "default" }) => {
  const sizeClasses =
    size === "large"
      ? "px-8 py-5 text-base sm:text-lg"
      : "px-7 py-4 text-sm sm:text-base";

  const handleClick = () => {
    if (typeof window !== "undefined") {
      if (typeof window.fbq === "function") {
        window.fbq("track", "Lead");
      }
      const url = new URL(window.location.href);
      url.searchParams.set("first_access", "joined");
      window.history.pushState({}, "", url.toString());
      window.dispatchEvent(new CustomEvent("mik-joined"));
    }
  };

  return (
    <motion.a
      data-testid={testId}
      href={WHATSAPP_LINK}
      target="_blank"
      rel="noopener noreferrer"
      onClick={handleClick}
      whileHover={{ scale: 1.045 }}
      whileTap={{ scale: 0.96 }}
      transition={{ type: "spring", stiffness: 400, damping: 20 }}
      className={`animate-cta-pulse group relative inline-flex w-full items-center justify-center gap-3 rounded-full bg-[#25D366] ${sizeClasses} font-display font-bold uppercase tracking-wide text-[#08290f] shadow-[0_10px_40px_-8px_rgba(37,211,102,0.7)] sm:w-auto`}
    >
      <svg viewBox="0 0 32 32" className="h-5 w-5 shrink-0 fill-[#08290f]" aria-hidden="true">
        <path d="M16.001 3C9.11 3 3.51 8.6 3.51 15.49c0 2.53.72 4.9 1.98 6.9L3 29l6.79-2.42a12.9 12.9 0 0 0 6.21 1.58h.01c6.89 0 12.49-5.6 12.49-12.49C28.5 8.6 22.9 3 16.001 3zm0 22.85h-.01a10.6 10.6 0 0 1-5.42-1.49l-.39-.23-4.03 1.44 1.32-3.93-.25-.4a10.63 10.63 0 0 1-1.63-5.65c0-5.86 4.77-10.63 10.63-10.63 5.85 0 10.62 4.77 10.62 10.63 0 5.85-4.77 10.26-10.84 10.26zm5.82-7.96c-.32-.16-1.88-.93-2.17-1.03-.29-.11-.5-.16-.71.16-.21.32-.82 1.03-1 1.24-.19.21-.37.24-.69.08-1.87-.94-3.1-1.67-4.33-3.79-.33-.56.33-.52.94-1.73.1-.21.05-.39-.05-.55-.11-.16-.71-1.71-.97-2.34-.26-.62-.52-.54-.72-.55-.19-.01-.4-.01-.62-.01-.21 0-.56.08-.85.4-.29.32-1.13 1.1-1.13 2.68 0 1.58 1.15 3.11 1.31 3.32.16.21 2.19 3.34 5.31 4.55 2.61 1.01 3.14.86 3.71.8.56-.05 1.87-.76 2.13-1.5.26-.74.26-1.37.18-1.5-.08-.13-.29-.21-.61-.37z" />
      </svg>
      <span>{label}</span>
    </motion.a>
  );
};
